import ReactPixel from "react-facebook-pixel";

/**
 * Meta Pixel wrapper for iCaresolutions.ca.
 * Central config so Pixel ID + toggle live in one place.
 *
 * Docs: https://developers.facebook.com/docs/meta-pixel/reference
 */
export const META_PIXEL_ID = "915794944805980";

const options = {
  autoConfig: true,
  debug: false,
};

let initialized = false;

export function initMetaPixel() {
  if (initialized) return;
  if (typeof window === "undefined") return;
  ReactPixel.init(META_PIXEL_ID, undefined, options);
  ReactPixel.pageView();
  initialized = true;
}

export function trackPageView() {
  if (!initialized) return;
  ReactPixel.pageView();
}

/**
 * Standard events — use these on real conversion moments.
 * https://developers.facebook.com/docs/meta-pixel/reference#standard-events
 */
export function trackEvent(name, data) {
  if (!initialized) return;
  ReactPixel.track(name, data);
}

export function trackCustom(name, data) {
  if (!initialized) return;
  ReactPixel.trackCustom(name, data);
}
